(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bespoke-appointment-booking"] && !Shopify.designMode) return;
  try {
    
  function initializeBespokeBooking(section) {
    if (section.dataset.bespokeBookingInitialized === 'true') return;
    section.dataset.bespokeBookingInitialized = 'true';

    const dialog = section.querySelector('[data-bespoke-booking-dialog]');
    const openButton = section.querySelector('[data-bespoke-booking-open]');
    const closeButton = section.querySelector('[data-bespoke-booking-close]');
    const backButton = section.querySelector('[data-bespoke-booking-back]');
    const locationsView = section.querySelector('[data-bespoke-booking-locations]');
    const calendarView = section.querySelector('[data-bespoke-booking-calendar]');
    const calendarTitle = section.querySelector('[data-bespoke-booking-calendar-title]');
    const iframe = section.querySelector('[data-bespoke-booking-iframe]');
    const fallback = section.querySelector('[data-bespoke-booking-fallback]');
    const unavailable = section.querySelector('[data-bespoke-booking-unavailable]');
    const externalLink = section.querySelector('[data-bespoke-booking-external]');
    const locationButtons = section.querySelectorAll('[data-bespoke-booking-location]');
    const iframeBaseTitle = iframe?.title || '';

    if (!dialog || !openButton) return;

    function resetCalendar() {
      iframe.src = 'about:blank';
      iframe.hidden = true;
      fallback.hidden = true;
      unavailable.hidden = true;
      calendarView.hidden = true;
      locationsView.hidden = false;
      calendarTitle.textContent = '';
      iframe.title = iframeBaseTitle;
    }

    function canEmbed(url) {
      try {
        const hostname = new URL(url).hostname.toLowerCase();
        return hostname === 'calendly.com'
          || hostname.endsWith('.calendly.com')
          || hostname === 'cal.com'
          || hostname.endsWith('.cal.com')
          || hostname === 'calendar.google.com';
      } catch {
        return false;
      }
    }

    function embedUrl(url) {
      const parsedUrl = new URL(url);

      if (parsedUrl.hostname === 'calendly.com' || parsedUrl.hostname.endsWith('.calendly.com')) {
        parsedUrl.searchParams.set('hide_gdpr_banner', '1');
        parsedUrl.searchParams.set('background_color', 'ffffff');
        parsedUrl.searchParams.set('text_color', '1d1d1d');
        parsedUrl.searchParams.set('primary_color', '1d1d1d');
      }

      return parsedUrl.toString();
    }

    function openLocation(button) {
      const url = button.dataset.bookingUrl || '';
      const fallbackUrl = button.dataset.bookingFallbackUrl || '';
      const name = button.dataset.bookingName || '';

      locationsView.hidden = true;
      calendarView.hidden = false;
      calendarTitle.textContent = name;
      iframe.hidden = true;
      fallback.hidden = true;
      unavailable.hidden = true;

      if (!url && !fallbackUrl) {
        unavailable.hidden = false;
        return;
      }

      if (url && canEmbed(url)) {
        iframe.title = name ? `${iframeBaseTitle} — ${name}` : iframeBaseTitle;
        iframe.src = embedUrl(url);
        iframe.hidden = false;
        return;
      }

      externalLink.href = url || fallbackUrl;
      fallback.hidden = false;
    }

    openButton.addEventListener('click', () => {
      dialog.showModal();
      const firstLocation = locationButtons[0];
      if (firstLocation) firstLocation.focus();
    });

    closeButton.addEventListener('click', () => dialog.close());
    backButton.addEventListener('click', resetCalendar);

    locationButtons.forEach((button) => {
      button.addEventListener('click', () => openLocation(button));
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', resetCalendar);
  }

  document.querySelectorAll('[data-bespoke-booking]').forEach(initializeBespokeBooking);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-bespoke-booking]');
    if (section) initializeBespokeBooking(section);
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://calendly.com') return;
    if (event.data?.event !== 'calendly.event_scheduled') return;

    window.dispatchEvent(new CustomEvent('cocoleni:appointment-booked', {
      detail: event.data.payload
    }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'bespoke_appointment_booked' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (window.CocoLeniDispatchEstimate) {
      window.CocoLeniDispatchEstimate.refresh();
      return;
    }

    const indiaDateParts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });

    const displayDate = new Intl.DateTimeFormat('en-IN', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });

    function getIndiaToday() {
      const parts = {};

      indiaDateParts.formatToParts(new Date()).forEach((part) => {
        if (part.type !== 'literal') {
          parts[part.type] = Number(part.value);
        }
      });

      return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
    }

    function addBusinessDays(startDate, numberOfDays) {
      const result = new Date(startDate.getTime());
      let addedDays = 0;

      while (addedDays < numberOfDays) {
        result.setUTCDate(result.getUTCDate() + 1);

        const weekday = result.getUTCDay();
        if (weekday !== 0 && weekday !== 6) {
          addedDays += 1;
        }
      }

      return result;
    }

    function formatISODate(date) {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }

    function refresh(root = document) {
      root.querySelectorAll('[data-dispatch-estimate]').forEach((estimate) => {
        const businessDays = Number(estimate.dataset.businessDays);
        const hydrationKey = String(businessDays);

        if (!businessDays || estimate.dataset.dispatchHydrated === hydrationKey) {
          return;
        }

        const dateTarget = estimate.querySelector('[data-dispatch-date]');
        if (!dateTarget) {
          return;
        }

        const estimatedDate = addBusinessDays(getIndiaToday(), businessDays);
        const time = document.createElement('time');
        time.dateTime = formatISODate(estimatedDate);
        time.textContent = displayDate.format(estimatedDate);

        dateTarget.replaceChildren(time);
        estimate.dataset.dispatchHydrated = hydrationKey;
      });
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            continue;
          }

          if (node.matches('[data-dispatch-estimate]')) {
            refresh(node.parentElement || document);
          } else if (node.querySelector('[data-dispatch-estimate]')) {
            refresh(node);
          }
        }
      }
    });

    window.CocoLeniDispatchEstimate = { refresh };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
    } else {
      refresh();
    }

    observer.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => refresh(event.target));
    window.addEventListener('pageshow', () => refresh());
  })();

  } catch(e) { console.error(e); }
})();
})();
